// The Options Reducer

import * as types from '../actions/action-types';

const initialState = {
  optionsData: [],
  propsRecieved: false
};

const optionsReducer = function(state = initialState, action) {
  switch(action.type) {
    case types.GET_OPTIONS_SUCCESS:
      return Object.assign({}, state, {
        optionsData: action.optionsData
      });

    case types.PROPS_RECIEVED_OPTIONS:
      return Object.assign({}, state, {
      propsRecieved: action.propsRecieved
    });
  }

  return state;
}

export default optionsReducer;


/** WEBPACK FOOTER **
 ** ./src/js/reducers/options-reducer.js
 **/